function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.8
},
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M.5 9.721C.5 8.156 3.617 3 10.5 3s10 5.155 10 6.721-3.117 6.722-10 6.722-10-5.157-10-6.722zm.984 0c0 1.177 2.8 5.738 9.017 5.738s9.016-4.561 9.016-5.738-2.8-5.736-9.016-5.736-9.017 4.561-9.017 5.736z",
  stroke: "transparent",
  strokeMiterlimit: 10
}),
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M10.502 13.823a4.1 4.1 0 114.1-4.1 4.1 4.1 0 01-4.1 4.1zm0-7.213a3.115 3.115 0 103.115 3.115 3.118 3.118 0 00-3.115-3.118z"
}),
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M.5 0h20v20H.5z"
}));

var SvgVisibility = function SvgVisibility(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 21,
      height: 20,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgVisibility, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Visibility.5e8c2dbb.svg";
export { ForwardRef as ReactComponent };